import React, { useEffect, useState } from 'react'

import { GoogleMap, Polygon, Marker } from '@react-google-maps/api'
import 'leaflet/dist/leaflet.css'
import { getBoundsNoArray } from '../../services/Afins'
import { kinks, polygon as turfPolygon } from '@turf/turf'

export interface TypesMaps {
  coord: google.maps.LatLng[] | google.maps.LatLngLiteral[]
  customHeight?: number | string
}

const brazilCoords = { lat: -14.235, lng: -51.9253 }

const Maps: React.FC<TypesMaps> = (props) => {
  const { coord, customHeight } = props
  const [map, setMap] = useState<google.maps.Map>()
  const [polygon, setPolygon] = useState<google.maps.Polygon>()
  const [kinksPoints, setKinksPoints] = useState<{ lat: number, lng: number }[]>([])

  const optionsPolygon: google.maps.PolygonOptions = React.useMemo(() => ({
    fillColor: kinksPoints.length > 0 ? '#ff4d4f' : 'aqua',
    strokeColor: kinksPoints.length > 0 ? '#ff4d4f' : 'aqua'
  }), [kinksPoints.length])

  const optionsMap: google.maps.MapOptions = React.useMemo(() => ({
    mapTypeId: 'hybrid',
    zoomControl: false,
    fullscreenControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    center: brazilCoords,
    zoom: 6,
    maxZoom: 23,
  }), [])
  const validateKinks = (coordinates) => {
    try {
      if (coordinates.length < 4) return [];
      const coords = coordinates.map((c) => [c.lng, c.lat]);
      coords.push(coords[0]);
      const poly = turfPolygon([coords]);
      const intersectKinks = kinks(poly);
      if (intersectKinks.features.length > 0) {
        return intersectKinks.features.map(feature => ({
          lng: feature.geometry.coordinates[0],
          lat: feature.geometry.coordinates[1]
        }));
      }
      return [];
    } catch {
      return [];
    }
  }

  useEffect(() => {
    if (map && coord && coord.length > 0) {
      const currentHash = JSON.stringify(coord);
      if (currentHash !== map.get('lastCoordHash')) {
        const bounds = getBoundsNoArray(coord);
        if (bounds && !bounds.isEmpty()) {
          map.fitBounds(bounds);
          map.set('lastCoordHash', currentHash);
        }
      }
    }
  }, [map, coord])

  useEffect(() => {
    if (polygon && coord) {
      polygon.setPath(coord)
      setKinksPoints(validateKinks(coord))
    }
  }, [coord, polygon])

  const containerStyle = React.useMemo(() => ({ minWidth: '100%', maxWidth: '500px', height: customHeight ?? '50vh' }), [customHeight])

  return (
    // @ts-ignore
    <GoogleMap
      onLoad={setMap}
      mapContainerStyle={containerStyle}
      options={optionsMap}
    >
      <Polygon onLoad={setPolygon} options={optionsPolygon} />
      {kinksPoints.map((point, index) => (
        <Marker
          key={`kink_${index}`}
          position={point}
          title="Vértice sobreposto!"
          clickable={false}
          icon={{
            path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
            fillColor: '#ff0000',
            fillOpacity: 1,
            strokeColor: '#000',
            strokeWeight: 1,
            scale: 1,
            labelOrigin: new window.google.maps.Point(0, -28)
          }}
          label={{ text: '!', color: 'white', fontWeight: 'semi-bold' }}
        />
      ))}
    </GoogleMap>
  )
}

export default Maps
